import { render, staticRenderFns } from "./OrderProductsEditor.vue?vue&type=template&id=71f6763e&scoped=true"
import script from "./OrderProductsEditor.vue?vue&type=script&lang=js"
export * from "./OrderProductsEditor.vue?vue&type=script&lang=js"
import style0 from "./OrderProductsEditor.vue?vue&type=style&index=0&id=71f6763e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6763e",
  null
  
)

export default component.exports